import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E7EB] bg-[#1a4a8a] text-[#FFFFFF]" data-testid="site-footer">
      <div className="container-editorial py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img loading="lazy" decoding="async" src="/logo.jpg" alt="Sdebitiamoci Srl" className="h-14 w-auto bg-white rounded p-2 mb-6"/>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white">Sdebitiamoci Srl · Saldo &amp; Stralcio</p>
          <h3 className="font-serif text-4xl md:text-5xl mt-4 leading-[0.95]">
            Senza debiti,<br/><span className="italic text-white">senza pensieri.</span>
          </h3>
          <p className="mt-6 max-w-md text-[#FFFFFF]/70 text-sm leading-relaxed">
            Un metodo onesto per abbattere i debiti. Consulenza gratuita, paghi una percentuale solo al successo dell'operazione.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white mb-4">Naviga</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/metodo" className="hover:text-[#CBD5E1]">Il Metodo</Link></li>
            <li><Link to="/casi" className="hover:text-[#CBD5E1]">Casi di Successo</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-[#CBD5E1]">Chi Siamo</Link></li>
            <li><Link to="/contatti" className="hover:text-[#CBD5E1]">Contatti</Link></li>
            <li><Link to="/login" className="hover:text-[#CBD5E1]">Area Clienti</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white mb-4">Contatti</p>
          <ul className="space-y-3 text-sm">
            <li><a href="https://wa.me/393927715932" target="_blank" rel="noreferrer" className="hover:text-[#CBD5E1]" data-testid="footer-whatsapp">WhatsApp diretto →</a></li>
            <li><a href="mailto:sdebitiamocisrl@libero.it" className="hover:text-[#CBD5E1]">sdebitiamocisrl@libero.it</a></li>
            <li><Link to="/prenota" className="hover:text-[#CBD5E1]">Prenota una chiamata →</Link></li>
            <li className="text-white">Risposta entro 24h</li>
          </ul>
          <div className="mt-8" data-testid="footer-legal-info">
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white mb-3">Dati societari</p>
            <p className="text-xs text-white leading-relaxed">
              Sdebitiamoci Srl<br/>
              Consulenza per la gestione e definizione del debito (saldo e stralcio)<br/>
              Email: sdebitiamocisrl@libero.it · WhatsApp: +39 392 771 5932
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-editorial py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#FFFFFF]/50">
          <p>© 2026 Sdebitiamoci Srl - Tutti i diritti riservati</p>
          <p>Le informazioni fornite non costituiscono consulenza legale. Ogni pratica è valutata singolarmente.</p>
        </div>
      </div>
    </footer>
  );
}
